export default __webpack_public_path__ + "static/media/svg-2.e9858a1b.svg";